var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable */
import * as React from "react";
import ReactSelect from "react-select";
import { asThemeConsumer } from "../../../theme/Theme";
import { joinClasses } from "../../../utils/Filters";
import { ensure } from "../../../utils/Optional";
import { sortBy } from "sort-by-typescript";
/**
 *
 * @param props
 */
var SelectComp = function (props) {
    var clazzName = joinClasses(props.className, "scl-a-select__field");
    var onChange = !!props.onChange
        ?
            function (evt) {
                evt.preventDefault();
                ensure(props.onChange)(evt.target.value);
            }
        : undefined;
    var onBlur = !!props.onBlur
        ?
            function (evt) {
                evt.preventDefault();
                ensure(props.onBlur)(evt.target.value);
            }
        : undefined;
    var onChangeMultiSelect = function (value) {
        if (!!props.onChange) {
            var val = value;
            ensure(props.onChange)(val.map(function (p) { return p.value; }).toString());
        }
    };
    if ((props.options && props.options.length > 1)) {
        props.unsorted ? props.options : props.options.sort(sortBy("label"));
    }
    if (!!props.placeholder
        && (props.options && props.options.length > 1)
        && !props.options.find(function (option) { return option.label === props.placeholder; })) {
        props.options.unshift({
            label: props.placeholder,
            value: "",
        });
    }
    return (React.createElement("div", { className: clazzName }, !!props.multiple ? (React.createElement(ReactSelect, { className: "scl-a-select__field-multi", classNamePrefix: "scl-a-select__field-multi-sub", options: props.options.filter(function (p) { return p.label !== props.placeholder; }), isMulti: true, placeholder: props.placeholder, onChange: onChangeMultiSelect, value: props.values, theme: function (theme) { return (__assign(__assign({}, theme), { borderRadius: 0, colors: __assign(__assign({}, theme.colors), { primary: "#1D1F20", primary75: "#FFFFFF", primary50: "#F0F1F3", primary25: "#E1E5EA", danger: "#fff", dangerLight: "#ff4d4f" }) })); } })) : (React.createElement("select", { disabled: !!props.disabled || (props.options && props.options.length <= 1), placeholder: props.placeholder, onChange: onChange, onBlur: onBlur, value: props.value || "", defaultValue: props.defaultValue }, props.options.map(function (opt, index) { return (React.createElement("option", { key: "".concat(index, "-").concat(opt.value), value: opt.value }, !!opt.label ? opt.label : opt.value)); })))));
};
/**
 *
 */
export var Select = asThemeConsumer(SelectComp);
